import DesktopMenu from '../DesktopMenu/DesktopMenu';
import MobileMenu from '../MobileMenu/MobileMenu';
import logo from '../../assets/Oilflex20AnosLogo.png'
import './Header.scss';
import { useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';

function Header() {
  const { languageIndex } = useContext(LanguageContext);

  const headerLinks = [
    {
      titleOne: 'INÍCIO',
      titleTwo: 'MAIS SOBRE NÓS',
      titleThree: 'CONTATO'
    },
    {
      titleOne: 'HOME',
      titleTwo: 'MORE ABOUT US',
      titleThree: 'CONTACT'
    }
  ];

  const titles = headerLinks[languageIndex];

  return (
    <header className='header'>
        <img src={logo} alt="logo da empresa" />
        <DesktopMenu title1={titles.titleOne} title2={titles.titleTwo} title3={titles.titleThree}/>
        <MobileMenu title1={titles.titleOne} title2={titles.titleTwo} title3={titles.titleThree} />
    </header>
  )
}

export default Header;